module.exports = __webpack_public_path__ + "static/media/phone-pe.6ba7f278.png";